<script setup lang="ts">
	import { onMounted, onUnmounted, ref } from "vue";
	import { useAuthStore } from "~/store/auth";
	import { isTimeOutStartEnd } from "~/utils";

	useHead({
		htmlAttrs: {
			dir: "rtl",
			lang: "fa-IR",
		},
		link: [
			// { rel: 'apple-touch-icon', sizes: '57x57', href: '/apple-icon-57x57.png' },
			// { rel: 'apple-touch-icon', sizes: '60x60', href: '/apple-icon-60x60.png' },
			// { rel: 'apple-touch-icon', sizes: '72x72', href: '/apple-icon-72x72.png' },
			// { rel: 'apple-touch-icon', sizes: '76x76', href: '/apple-icon-76x76.png' },
			// { rel: 'apple-touch-icon', sizes: '114x114', href: '/apple-icon-114x114.png' },
			// { rel: 'apple-touch-icon', sizes: '120x120', href: '/apple-icon-120x120.png' },
			// { rel: 'apple-touch-icon', sizes: '144x144', href: '/apple-icon-144x144.png' },
			// { rel: 'apple-touch-icon', sizes: '152x152', href: '/apple-icon-152x152.png' },
			// { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-icon-180x180.png' },
			// { rel: 'icon', type: 'image/png', sizes: '192x192', href: '/android-icon-192x192.png' },
			// { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png' },
			// { rel: 'icon', type: 'image/png', sizes: '96x96', href: '/favicon-96x96.png' },
			// { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16x16.png' },
			// { rel: 'manifest', href: '/manifest.json' }
		],
		meta: [
			{ name: "msapplication-TileColor", content: "#ffffff" },
			// { name: 'msapplication-TileImage', content: '/ms-icon-144x144.png' },
			{ name: "theme-color", content: "#ffffff" },
		],
		script: [
			{
				tagPosition: "head",
				/*to prevent Firefox FOUC, this must be here*/
				innerHTML: `let FF_FOUC_FIX;`,
			},
			{
				tagPosition: "bodyOpen",
				innerHTML: "0",
			},
		],
	});
	const authStore = useAuthStore();
	// console.log(
	// 	"watch_limit_start_hour:",
	// 	authStore.user?.watch_limit_start_hour,
	// );
	// console.log("watch_limit_end_hour:", authStore.user?.watch_limit_end_hour);
	// console.log("now:", new Date().getHours());
	// console.log(
	// 	"isTimeOut: ",
	//
	// );
	const isTimeOut = computed(() => {
		if (!authStore.user) return false;
		if (!authStore.userAccount) return false;
		if (authStore.userAccount.is_default_account) return false;
		if (!authStore.hasPin()) return false;
		if (
			!authStore.user.watch_limit_start_hour ||
			!authStore.user.watch_limit_end_hour
		)
			return false;
		return isTimeOutStartEnd(
			authStore.user?.watch_limit_start_hour,
			authStore.user?.watch_limit_end_hour,
		);
	});

	const page = ref();
	const handleResize = (_?: UIEvent) => {
		if (page.value) {
			page.value.style.width = "100%";
		}
	};
	onMounted(() => {
		if (isTimeOut.value && authStore.pinUnlocked()) {
			authStore.lockPin();
		}
		handleResize();
		window.addEventListener("resize", handleResize);
	});
	onUnmounted(() => {
		window.removeEventListener("resize", handleResize);
	});
</script>

<template>
	<div ref="page" class="select-none">
		<NuxtRouteAnnouncer />
		<NuxtLoadingIndicator />

		<NuxtLayout>
			<NuxtPage />
		</NuxtLayout>
	</div>
</template>

<style></style>
<!--.page-enter-active,-->
<!--.page-leave-active {-->
<!--transition: all 0.2s;-->
<!--}-->

<!--.page-enter-from,-->
<!--.page-leave-to {-->
<!--filter: grayscale(1);-->
<!--}-->
